import React from 'react';

import { css } from '@emotion/css';
import { theme } from 'theme';

export const NoChartData = ({ title }: { title: string }) => (
  <div
    className={css`
      display: flex;
      justify-content: center;
      align-items: center;
      height: 75px;
      width: 100%;
      background-color: ${theme.colors.neutral[100]};
      border-radius: 4px;
      border: 1px solid ${theme.colors.neutral[300]};
      padding: 8px;
      font-size: 14px;
      font-weight: 500;
      color: ${theme.colors.neutral[500]};
    `}
  >
    {title}
  </div>
);
